const comments = [
  { name: '影迷小张', time: '2小时前', text: '找了好久的高清资源终于在这里看到了，播放真的不缓冲，画质也很清晰，已经推荐给朋友们了！', tag: '电影爱好者' },
  { name: '追剧达人', time: '5小时前', text: '最近在追的几部热播剧这里都能看，更新速度很快，手机上看也很流畅，通勤路上看剧太方便了。', tag: '电视剧观众' },
  { name: '动漫迷阿伟', time: '8小时前', text: '作为一个老二次元，这个站的动漫资源真的很全，新番更新也快，而且没有乱七八糟的广告，体验满分。', tag: '动漫粉丝' },
  { name: '综艺控小陈', time: '昨天', text: '周末在家一口气看了好几期综艺，画质太棒了！而且分类很清晰，找节目特别方便。', tag: '综艺观众' },
  { name: '老李看电影', time: '2天前', text: '退休后每天都要看两部电影，蘑菇影视资源多、播放稳定，操作也很简单，老年人也能轻松上手。', tag: '资深观众' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          观众口碑
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          来自真实观众的声音，用心做好每一次播放
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg p-5 border border-background-200/60 ${i === 0 ? 'lg:col-span-2' : ''}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">{c.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}